import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Alert")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Close")

import { ref, watch } from "vue";
import { useEventsBus } from '@/functions/utility';
import {
    MDBBtn,
    MDBModal,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-vue-ui-kit';

// alert modal refs

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const alertModal = ref(false);
const alertModalContent = ref('This is an alert');

function showModal(content: string) {
    // set modal values
    alertModalContent.value = content;

    // open modal
    alertModal.value = true;
}

function closeModal() {
    alertModal.value = false;
}


// setup event listener for alerts
const { bus } = useEventsBus();
watch(()=> bus.value.get('newAlert'), (val) => {
    // destruct the parameters
    const [ newAlert ] = val ?? [];
    console.log(`Received event value: ${newAlert}`);
    showModal(newAlert);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MDBModal), {
    id: "alertModal",
    tabindex: "-1",
    labelledby: "alertModalLabel",
    modelValue: alertModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((alertModal).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(MDBModalHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(MDBModalTitle), { id: "alertModalLabel" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(MDBModalBody), { innerHTML: alertModalContent.value }, null, 8, ["innerHTML"]),
      _createVNode(_unref(MDBModalFooter), null, {
        default: _withCtx(() => [
          _createVNode(_unref(MDBBtn), {
            color: "danger",
            onClick: closeModal
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})